import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalNews`,
  scopes: ExtHubRequest,
});

api.createEntities([{ name: 'GetNewsList' }, { name: 'GetNewsListByProduct' }]);

const GetNewsList = () => api.endpoints.GetNewsList.post();
const GetNewsListByProduct = (body) => api.endpoints.GetNewsListByProduct.post(body);

export { GetNewsList, GetNewsListByProduct };
